import React, { useState } from 'react';
import { FileDownloadButton } from 'components/BulkUploads/BladeComponents/FileDownloadButton';
import { Box } from '@razorpay/blade/components';

type DownloadSampleTemplateProps = {
  onDownloadTemplate: () => void;
};

export const DownloadSampleTemplate = ({ onDownloadTemplate }: DownloadSampleTemplateProps) => {
  const [fileDownloaded, setFileDownloaded] = useState(false);

  return (
    <Box marginBottom="spacing.8">
      <FileDownloadButton
        href=""
        fileDownloaded={fileDownloaded}
        setFileDownloaded={setFileDownloaded}
        onClick={onDownloadTemplate}
        buttonText="Download Template"
      />
    </Box>
  );
};
